import AppBaseComponent from '../../../components/AppBaseComponent';
import ApplicationLayout from "../../../layouts/ApplicationLayout";
import { connect } from "react-redux";
import Ax from "../../../components/hoc/Ax";
import moment from "moment";
import tapIcon from "../../../services/TapIcon";
import HttpAPICall from "../../../services/HttpAPICall";
import Loader from "../../../components/ui/Loader/Loader";
import { Collapse, Modal } from 'bootstrap';
import {DisplayListPagination, DisplaySearchCriteria, PeriodSelectionWithCustom} from "../../../components/TapUi/index";
import {Link} from "react-router-dom";
import DownloadFile from "../../../services/DownloadFile";
import TapSelect from "../../../components/ui/TapSelect";
import { Helmet } from 'react-helmet';
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import React from 'react';

class FuelStationSummary extends AppBaseComponent {
    
    constructor(props) {
        super(props);

        let today                                     =   new Date()
        this.reportFilterFormInitialState   =   {
            site_group_ids                  :      [],
            search_site_ids                 :       [],
            search_fuel_station_name        :       [],
            search_fuel_type                :       '',
            search_fuel_station_type        :       '',
            date_range                      :       '',
            date_range_start                :       '',
            date_range_end                  :       '',
        };
        
        this.reportFilterFormLabel          =   {
            site_group_ids                  :       'Site Groups : ',
            search_site_ids                 :       'Sites : ', 
            search_fuel_station_name        :       'Fuel Station Name : ',
            search_fuel_type                :       'Fuel Type : ',
            search_fuel_station_type        :       'Fuel Station Type : ',
            date_range                      :       'Date Range : ',
        };
         
        this.state                          =   {
            formDataLoaded                      :   false,
            reportDownloadBtn                   :   false,
            reportDownloading                   :   false,
            all_warehouses                      :   [],
            reportFilterForm                    :   {...this.reportFilterFormInitialState},
            submittedReportFilterForm           :   {...this.reportFilterFormInitialState},
            listing_loading                     :   false,
            listingData                         :   [],
            listingMeta                         :   null,  
            allItemTags                         :   [],
            manufactures                        :   [],
            allStatusOptions                    :   [],
            searchedAssets                      :   [],
            iam_asset_types                     :   [],
            iam_user_sites                      :   [],  
            allSiteGroupsList                   :   [],
            all_periods                         :   [],
            iam_status_list                     :    [],
            allFuelStationTypes                 :    [],
            allFuelTypes                        :    [],
            allFuelStationList                  :    [],
            reportData                          :   null,  
            criteriaHeight                          :   0           

        };
                   this.criteriaRef        =   React.createRef();

        this.formDataUrl        =   IAM_API_BASE_URL_2 + '/report/fuel_station_summary/form_data';
        this.reportUrl          =   IAM_API_BASE_URL_2 + '/report/fuel_station_summary';

    }

    componentDidMount() {
        this.initilaizeAppDataToFilterForm(this.props);
    }
     updateCriteriaHeight = () => {
        if (this.criteriaRef.current) {
            const height = this.criteriaRef.current.offsetHeight;
            if (this.state.criteriaHeight !== height) {
                this.setState({ criteriaHeight: height });
            }
        }
    };
    componentDidUpdate(prevProps, prevState) {
        if (prevState.formSearchedElems !== this.state.formSearchedElems) {
            this.updateCriteriaHeight();
        }
    }
    componentWillReceiveProps(nextProps){
        if(nextProps.iam_user_sites !== this.props.iam_user_sites) {
            this.initilaizeAppDataToFilterForm(nextProps);
        }
        
    }
    
    initilaizeAppDataToFilterForm           =   (pr)  =>  {
        
        const report_name   =   'fuel_station_summary';
        const reportData    =   pr?.report_listing.length > 0 ? pr.report_listing.filter(d => d.key === report_name) : [];

        this.setState({
            reportData                  :   reportData.length > 0 ? reportData[0] : null,
        })


        let all_periods             =       [...pr.all_periods , {key : 'custom' , display : 'Custom Date Range'}] ;

        HttpAPICall.withAthorization('GET', this.formDataUrl, this.props.access_token, null, null, (response) => {
                this.setState({
                    access_token                :   pr.access_token,
                    formDataLoaded              :   true,
                    all_periods                 :   all_periods ,
                    iam_user_sites              :   pr.iam_user_sites ? pr.iam_user_sites.map((s) => { return {value: s.id, label: `${s.site_name} (${s.site_code})`}}) : [],
                    allFuelStationList          :   pr.fuel_stations ? pr.fuel_stations.map((s) => { return {value: s.id, label: s.fuelstation_name}}) : [],
                    allFuelStationTypes         :   response.data && response.data.station_types && response.data.station_types.length > 0 ? response.data.station_types.map((s) => { return { value: s.key, label: s.name }; }) : [],
                    allFuelTypes                :   response.data && response.data.fuel_types && response.data.fuel_types.length > 0 ? response.data.fuel_types.map((s) => { return { value: s.id, label: s.fuel_type }; }) : [],
                    allSiteGroupsList           :   response.data && response.data.site_groups && response.data.site_groups.length > 0 ? response.data.site_groups.map(oc => { return ({ value: oc.id, label: oc.name, linked_sites: oc.site_ids }) }) : [],
                    allStatusOptions            :   response.data && response.data.consolidated_status && response.data.consolidated_status.length > 0 ? response.data.consolidated_status.map((s) => { return { value: s.status, label: s.status_text }; }) : [],
                }, () => {
                    let ParamObject                 =   new URLSearchParams(this.props.location.search);
            
                    if(ParamObject.get('date_range')) {
                        let period                =   all_periods.find(p => p.key === ParamObject.get('date_range'));
                        let startDate             =   period && period.dateFromYmd &&  moment(period.dateFromYmd).format('YYYY-MM-DD');
                        let endDate               =    period && period.dateToYmd && moment(period.dateToYmd).format('YYYY-MM-DD')
                        let updateFilterForm      =   {date_range : ParamObject.get('date_range'), date_range_start :  startDate,date_range_end : endDate };
                        setTimeout(() => {
                            this.setState({ reportFilterForm: { ...this.state.reportFilterForm, ...updateFilterForm } },
                                function () {
                                    this.reportFilterFormSubmit();
                                });
                        }, 1000)
                     
                    }else{
                        this.reportFilterhandler()
                    }
                    
                   
                });
            });
    }
    
    reportFilterFormSubmit                  =   (event=null)  =>  {
        event && event.preventDefault();
        event && this.reportFilterhandler(true);
       
        let serachFormKeys                  =   Object.keys(this.state.reportFilterForm);
        let searchedElems                   =   [];
        let itemSearchParams                =   {};
       
        serachFormKeys.map((key)        =>  {
            let label                       =   this.reportFilterFormLabel[key];
            let value                       =   this.state.reportFilterForm[key];
            if(value && value.toString().length > 0) {
                itemSearchParams[key]      =   value;
                if(label) {
                    let show_val            =   value;
                    
                    if(key == 'site_group_ids') {
                        show_val            =   this.state.allSiteGroupsList.filter((s) => value.includes(s.value)).map(s => s.label).join(', ')
                    }
                   
                    if(key == 'search_site_ids') {
                        show_val            =   this.state.iam_user_sites.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                   
                    if(key == 'search_fuel_station_name') {
                        show_val            =  this.state.allFuelStationList.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if(key == 'search_fuel_type') {
                        show_val            =  this.state.allFuelTypes.filter((s) => value == s.value).map(s => s.label).join(', ');
                    }
                    if(key == 'search_fuel_station_type') {
                        show_val            =  this.state.allFuelStationTypes.filter((s) => value == s.value).map(s => s.label).join(', ');
                    }
                    if(key == 'date_range') {
                        let  start_range         =      moment(this.state.reportFilterForm.date_range_start).format('DD-MMM-YYYY');
                        let end_range            =      moment(this.state.reportFilterForm.date_range_end).format('DD-MMM-YYYY')
                        let display_custom       =      `Custom Date Range (${start_range} - ${end_range})`
                        show_val                 =     this.state.all_periods.filter((s) => value.includes(s.key)).map(s => s.display_with_date ? s.display_with_date : display_custom);
                    }
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        this.setState({
            submittedReportFilterForm           :   {...this.state.reportFilterForm},
            formSearchedElems                   :   searchedElems
        }, () => {
           this.loadListingTblData(1);
        });
    }
    
    loadListingTblData                      =   (page=1) => {
        this.setState({
            listing_loading             :   true,
            listingData                 :   [],
            listingMeta                 :   null,
            reportDownloadBtn           :   false,
            reportDownloading           :   false
        });
        let params                          =   {page:page, ...this.state.submittedReportFilterForm};
        HttpAPICall.withAthorization('GET', this.reportUrl, this.props.access_token, params, {}, (response) => {
            let respData                =   response.data;
            this.setState({
                listingData                 :   respData.data,
                reportDownloadBtn           :   true,
                listingMeta                 :   {
                    from                        :   respData.from,
                    to                          :   respData.to,
                    total                       :   respData.total,
                    last_page                   :   respData.last_page,
                    per_page                    :   respData.per_page,
                    current_page                :   respData.current_page
                }
            });
        }, (err) => {
            this.reportFilterhandler();
        }).then(() => {
            this.setState({listing_loading: false});
        });
    }

    reportDownloadHandler                   =   ()  =>  {
        this.setState({ reportDownloading: true});
        HttpAPICall.withAthorization('GET', this.reportUrl, this.props.access_token, {...this.state.submittedReportFilterForm, download : 'download'} , {} , (response) => DownloadFile.file(response.data.file_path)).then(() => this.setState({reportDownloading: false}));
    }
    
    reportFilterhandler                     =   (collapse = true)  =>  {
        collapse && new Collapse(document.getElementById('reportFilterForm'));
        if(document.getElementById('pageTbl')) {
            document.getElementById('pageTbl').scroll({ top: 0, behavior: 'smooth' });
        }
    }
 
   
    closeReport                             =       ()      =>  {
        this.props.history.goBack()
    }

    reportSearchClear                  =        ()             =>        {
        this.setState({
            formSearchedElems               :           [],
            reportFilterForm                :           {...this.reportFilterFormInitialState},
            submittedReportFilterForm       :           {...this.reportFilterFormInitialState},
        }, () => {
            this.loadListingTblData(1);
        });
    }
    
    pageTitleBarJsx                         =   ()  =>  {
        return (<div className="page_title row m0">
            <div className="col-sm-12">
                <h3><tapIcon.FontAwesomeIcon icon={tapIcon.faPallet} /> Fuel Station Summary Report </h3>
                <div className="text-end mt15">
                    {this.state.reportDownloadBtn ? (<button disabled={this.state.reportDownloading || this.state.reportData?.download_access === 'N'} type="button" onClick={this.reportDownloadHandler} className="btn btn-primary"><tapIcon.FontAwesomeIcon icon={tapIcon.faDownload} /> Download Detailed Report {this.state.reportDownloading ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}</button>) : null}
                    <button type="button" disabled={!this.state.formDataLoaded} onClick={this.reportFilterhandler} className="btn btn-secondary">Change Filter</button>
                    <button type="button" className="btn btn-secondary" onClick={this.closeReport}>
                        <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                    </button>
                </div>
            </div>
        </div>);
    }
    
    reportFilterFormJsx                     =   ()  =>  {
        return (<div id="reportFilterForm" className="bg-white collapse " >
               <form onSubmit={this.reportFilterFormSubmit} className={['p-3', 'filter_form'].join(' ')}>
                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Site Group</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={this.state.allSiteGroupsList}
                            changeEvent={(selectedOption) => {

                                this.setState({
                                    reportFilterForm: {
                                        ...this.state.reportFilterForm,
                                        site_group_ids: selectedOption && selectedOption.length > 0 ? selectedOption.map(o => o.value) : [],
                                        search_site_ids: selectedOption && selectedOption.length > 0 ? selectedOption.map(s => s.linked_sites).flat() : []
                                    }
                                })
                            }}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={this.state.allSiteGroupsList.filter(s => this.state.reportFilterForm.site_group_ids.includes(s.value))}
                            placeholder="Select Site Group"
                        />
                    </div>
                </div>
                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Site Name</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={this.state.iam_user_sites}
                            changeEvent={(selectedOption) => {
                                this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_site_ids');
                            }}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            menuPlacement="bottom"
                            value={this.state.iam_user_sites.filter(s => this.state.reportFilterForm.search_site_ids.includes(s.value))}
                            placeholder="Select Sites"
                        />
                    </div>
                </div>

               
                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Fuel Type</label>
                    <div className="col-sm-6">
                    <TapSelect
                            options={this.state.allFuelTypes}
                            changeEvent={(selectedOption) => {
                                this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_fuel_type');
                            }}
                            isSearchable={true}
                            isClearable={true}
                            value={this.state.allFuelTypes.find(s => this.state.reportFilterForm.search_fuel_type == s.value)}
                            placeholder="Select Fuel Type"
                        />
                        
                    </div>
                </div>
                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Fuel Station Type</label>
                    <div className="col-sm-6">
                    <TapSelect
                            options={this.state.allFuelStationTypes}
                            changeEvent={(selectedOption) => {
                                this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_fuel_station_type');
                            }}
                            isSearchable={true}
                            isClearable={true}
                            value={this.state.allFuelStationTypes.find(s => this.state.reportFilterForm.search_fuel_station_type == s.value)}
                            placeholder="Select Fuel Station Type"
                        />
                        
                    </div>
                </div>
             
                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Fuel Station Name</label>
                    <div className="col-sm-6">
                       <TapSelect
                            options={this.state.allFuelStationList}
                            changeEvent={(selectedOption) => {
                                this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_fuel_station_name');
                            }}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={this.state.allFuelStationList.filter(s => this.state.reportFilterForm.search_fuel_station_name.includes(s.value))}
                            placeholder="Select Fuel Station"
                        />
                    </div>
                </div>
                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end require">Select Period</label>
                    <div className="col-sm-6">
                        <PeriodSelectionWithCustom
                            periods              =       {this.state.all_periods ? this.state.all_periods : []}
                            value                =       {this.state.reportFilterForm.date_range}
                            startDate            =       {this.state.reportFilterForm.date_range_start}
                            endDate              =       {this.state.reportFilterForm.date_range_end}
                            required             =       {true}
                            onSelectPeriod       =       {(period, startDate, endDate) => {
                                this.setState({
                                    reportFilterForm
                                        : {
                                        ...this.state.reportFilterForm,
                                        date_range          :       period,
                                        date_range_start    :       startDate ? startDate : null,
                                        date_range_end      :       endDate ? endDate : null
                                    }
                                });
                            }}

                        />
                    </div>
                </div>
                <div className="row">
                    <div className="pb-3 col-9 text-end">
                        <button type="submit" disabled={this.state.listing_loading ? true : false} className="btn btn-primary px-4" >Show Report</button>
                    </div>
                    <hr />
                </div>
            </form>
        </div>);
    }
    
    reportListingDisplayJsx                 =   ()  =>  {
       
        return (<div className="bg-white">
            { this.state.listing_loading ? <Loader /> : null }
           { !this.state.listing_loading && this.state.reportDownloadBtn == true
                ? this.reportTableJsx() : null
            }
       
        </div>)

    }
    
    reportTableJsx                          =   ()  =>  {
        return (<Ax>
            <table className="table table-bordered  table-sm align-middle bg-white mt-2">
                <thead className="align-middle table-secondary" style={{
                    top: `${this.state.criteriaHeight}px`,
                    position: 'sticky',
                }}>
                    <tr className="text-center">
                        <th style={{ width: "24%" }} className="text-start">Fuel Station Name</th>
                        <th style={{ width: "13%" }}>Fuel Type</th>
                        <th style={{ width: "13%" }}>Unit</th>
                        <th style={{ width: "10%" }} className="text-end">Opening Balance</th>
                        <th scope="col" style={{ width: "10%" }} className="text-end">Received</th>
                        <th scope="col" style={{ width: "10%" }} className="text-end">Issued</th>
                        <th style={{ width: "10%" }} className="text-end">Closing Balance</th>
                        <th style={{ width: "10%" }}>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.listingData && this.state.listingData.length > 0
                        ? (this.state.listingData.map((data, index) => {
                            return (<Ax>
                                {data.fuels && data.fuels.length > 0
                                    ? data.fuels.map((fuelData, key) => {
                                        let obj = {'fuel_station_id' : data.id,'fuel_type_id' : fuelData.id ,'date_range' : this.state.reportFilterForm.date_range,'date_range_start': this.state.reportFilterForm.date_range_start,'date_range_end': this.state.reportFilterForm.date_range_end}
                                        return (<tr className="text-center">
                                            {key == 0 && <Ax>
                                                <td className="text-start text-capitalize" rowSpan={data.fuels.length}>{data.fuelstation_name ? data.fuelstation_name : "-"}</td>
                                           </Ax>}
                                           <td>{fuelData.fuel_type ? fuelData.fuel_type : "-"}</td>
                                            <td>{fuelData.unit ? fuelData.unit : "-"}</td>
                                            <td className="text-end">{fuelData.balance && fuelData.balance.opening_balance ? fuelData.balance.opening_balance : "0"}</td>
                                            <td className="text-end">{fuelData.balance && fuelData.balance.received ? fuelData.balance.received : "0"}</td>
                                            <td  className="text-end" >{fuelData.balance && fuelData.balance.issued ? fuelData.balance.issued : "0"}</td>
                                            <td  className="text-end">{fuelData.balance && fuelData.balance.closing_balance ? fuelData.balance.closing_balance : "0"}</td>
                                            <td className="link-primary text-center">
                                                            <Link target="_blank" to={{ pathname: "/report/fuel_station_ledger", search: "?" + new URLSearchParams(obj).toString() }}>View Ledger</Link></td>
                                            
                                        </tr>)
                                    }) : null}
                            </Ax>)
                        }))
                        : <tr><td className="text-center" colSpan={9}>No Record Found</td></tr>
                    }
                </tbody>
            </table>
        </Ax>);
    }

    
    render                                  =   ()  =>  {
        return (<ApplicationLayout>
            <Helmet><title>Fuel Station Summary - Report</title></Helmet>
            {this.pageTitleBarJsx()}
            <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div id="pageTbl" className="pageTbl col-12 pb-2">
                        {this.state.formDataLoaded
                            ? (<Ax>
                                {this.reportFilterFormJsx()}
                                 <div ref={this.criteriaRef}
                                    style={{
                                        position: 'sticky',
                                        top: 0,
                                        background: 'white',
                                    }}>
                                <DisplaySearchCriteria searchedElems={this.state.formSearchedElems}  onClearFilter={this.reportSearchClear} />
                                </div>
                                {this.reportListingDisplayJsx()}

                            </Ax>)
                            : <Loader />
                        }

                        {this.state.reportDownloadBtn == true
                            ? <DisplayListPagination meta={this.state.listingMeta} onPageChange={(e) => this.loadListingTblData(e.selected + 1)} />
                            : null
                        }
                    </div>
                </div>
            </div>

        </ApplicationLayout>);
    }
    
}

const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        iam_user_sites          :   state.app && state.app.user_sites ? state.app.user_sites : [],
        all_periods             :   state.app && state.app.all_periods ? state.app.all_periods : [],
        fuel_stations           :   state.app && state.app.fuel_stations ? state.app.fuel_stations : [],
        report_listing          :   state.app && state.app.report_listing && state.app.report_listing.length > 0 ? state.app.report_listing : []
    };
};

export default connect(mapStateToProps)(FuelStationSummary);